<template>
  <div class="table-responsive">
    <b-table
      show-empty
      class="sticky-head-table table-wrapper datatables"
      :fields="computedFields"
      :items="items"
    >
      <template #empty>
        <div v-show="!isBusy" class="text-center my-4">{{ $t('global.emptyTable') }}</div>
      </template>

      <template #cell(status)="data">
        <div :class="`status ${data.value ? 'status--success' : 'status--failed'}`">
          <i v-if="data.value" class="mc-icon icon-fill_checkmark"></i>
          <i v-else class="mc-icon icon-outline_close"></i>
        </div>
      </template>

      <template #cell()="{ value }">
        <div class="d-flex flex-column detail-row">
          <div class="detail-row__value">
            {{ value.value || '-' }}
          </div>
          <div class="detail-row__error">
            {{ value.error || '' }}
          </div>
        </div>
      </template>
      <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"></slot>
      </template>
    </b-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    fields: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sorts: {},
      totalCount: 0,
      page: 1,
      limit: 10,
      isBusy: false,
    }
  },
  computed: {
    computedFields() {
      const field = cloneDeep(this.fields)
      field.forEach((item) => (item.label = `${this.$t(item.label)}`))
      return field
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(table) {
  td {
    position: relative;
    vertical-align: middle;
  }

  .label {
    white-space: nowrap;
    color: black;
  }

  .sort-icon-up,
  .sort-icon-down {
    position: absolute;
  }

  .sort-icon-up {
    top: 1px;
  }

  .sort-icon-down {
    bottom: 1px;
  }

  .status {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: grid;
    place-items: center;

    &--success {
      color: $green;
      background-color: $green-100;
    }

    &--failed {
      color: $red;
      background-color: #fee8e5;
    }
  }

  .detail-row {
    &__error {
      font-size: 10px;
      color: $red-400;
    }
  }
}
</style>
